/**
 * Registers a directive for displaying a rich text editor tooltip.
 * @param {object} module - The AngularJS module to which the directive will be added.
 */
export default function registerRichTextEditorTooltipDirective(module) {
    module.directive('richTextEditorTooltip', ['$document',
        function($document) {
            return {
                restrict: 'A',
                link: function (scope, element, attributes) {
                    // Extract the tooltip content and image URL from the attributes
                    var content = attributes.ibTooltip;
                    var image = attributes.ibImage;

                    // Create a span element to hold the tooltip content, replacing newlines with <br> tags
                    var content_element = angular.element('<span>').html(content.replace(/\n/g, "<br />"));

                    // If an image URL is provided, create an image element and append it to the content
                    if (image) {
                        var image_container = angular.element('<p>');
                        var image_element = angular.element('<img>').attr({
                            'src': image
                        });
                        content_element.append(image_container.append(image_element));
                    }

                    // Create the tooltip container and append the content element to it
                    var tooltip = angular.element('<div>')
                        .addClass('richtexteditor-tooltip')
                        .append(content_element)
                        .hide();

                    // Show the tooltip on mouse enter
                    element.on('mouseenter', function () {
                        tooltip.show();
                    });

                    // Hide the tooltip on mouse leave
                    element.on('mouseleave', function () {
                        tooltip.hide();
                    });

                    // Append the tooltip to the element
                    element.append(tooltip);
                }
            };
        }]
    );
}
